import { render } from "./categoryCard.vue?vue&type=template&id=b66ae70a"
import script from "./categoryCard.vue?vue&type=script&lang=js"
export * from "./categoryCard.vue?vue&type=script&lang=js"

import "./categoryCard.vue?vue&type=style&index=0&id=b66ae70a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__